<div class="popup">
  <div class="center">{{ type }}</div>
  <div class="width-min" fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="43%">
      <div *ngIf="profile1" fxLayout="column" fxLayoutAlign="start left">
        <div class="item">
          <app-smart-op-avatar [profile]="profile1"> </app-smart-op-avatar>
        </div>
        <ng-container>
          <div class="item left" *ngIf="period1">Période: {{ period1 }}</div>
          <div class="item left">Date: {{ date1 }}</div>
        </ng-container>
      </div>
    </div>
    <div fxFlex="14%">
      <img src="assets/icons/swap.svg" alt="" class="exchange-icon" />
    </div>
    <div fxFlex="43%">
      <div *ngIf="profile2" fxLayout="column" fxLayoutAlign="start left">
        <div class="item">
          <app-smart-op-avatar [profile]="profile2"> </app-smart-op-avatar>
        </div>
        <ng-container>
          <div class="item left" *ngIf="period2">Période: {{ period2 }}</div>
          <div class="item left">Date: {{ date2 }}</div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
